import { buildNow, TimeGetter } from 'lib-common';

let _currentTime: TimeGetter;

export const setupTimeGetter = (stubTime?: string): void => {
  _currentTime = buildNow(stubTime);
};

export const currentTime: TimeGetter = () => _currentTime();
